import { writable } from "svelte/store";

export type Template = {
    id: number;
    name: string;
    subject: string;
    body: string;
    from_email: string;
    is_default: boolean;
};

const emailTemplates = writable<Template[]>([]);
export { emailTemplates };
